import { useState, useEffect } from 'react';
import { Grid } from '@mui/material';
import ImageListItem from '@mui/material/ImageListItem';
import { useNavigate } from 'react-router-dom';
import { useErrorHandler } from 'react-error-boundary';
import { makeStyles } from '@mui/styles';
import CommonForm from './CommonForm';
import login from '../../assets/gifs/login.gif';
import LoadingCoffee from '../loading_coffee/LoadingCoffee';
import { useDispatch, useSelector } from 'react-redux';
import { userLogin } from '../../redux/actions/AccessAction';
import GlobalSnackbar from '../../components/global_snackbar/GlobalSnackbar';
import { decrypt, encrypt } from '../../util/Security';

const useStyles = makeStyles((theme) => ({
  paperStyle: {
    boxShadow: '0px 6px 22px rgba(0, 0, 0, 0.08)',
    width: '80%',
    margin: 0,
    paddingBottom: 48,
  },
}));

const Login = () => {
  const classes = useStyles();
  const [validator, setValidator] = useState({});
  const [isSubmited, setIsSubmited] = useState(false);
  const navigate = useNavigate();
  const errorHandler = useErrorHandler();
  const [loadingAnimation, setLoadingAnimation] = useState(false);
  const dispatch = useDispatch();
  const { loginDetails } = useSelector((state) => state.accessState);
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: '',
    severity: 'info',
  });
  const [credentials, setCredentials] = useState({
    email: '',
    password: '',
  });
  const [rememberMeVal, setRememberMeVal] = useState(
    !!localStorage.getItem('userCred')
  );

  const manageRememberMe = (e) => {
    setRememberMeVal((rememberMeVal) => !rememberMeVal);
  };
  useEffect(() => {
    if (!rememberMeVal) localStorage.removeItem('userCred');
  }, [rememberMeVal]);

  useEffect(() => {
    const userCred = localStorage.getItem('userCred');
    if (userCred) {
      const decryptedCred = decrypt(userCred);
      setCredentials(decryptedCred);
    }
  }, []);

  useEffect(() => {
    if (Object.keys(validator).length === 0 && isSubmited) {
      if (!rememberMeVal) localStorage.removeItem('userCred');
      if (rememberMeVal) {
        const encryptedCred = encrypt(credentials);
        localStorage.setItem('userCred', encryptedCred);
      }
      dispatch(userLogin(credentials.email, credentials.password));
    }
  }, [validator, isSubmited]);

  useEffect(() => {
    if (loginDetails) {
      if (loginDetails?.status === 200) {
        setLoadingAnimation(true);
        setTimeout(() => {
          navigate('/profile');
        }, 2000);

        //Store login details
        window.localStorage.setItem(
          'login',
          encrypt({
            candidateId: loginDetails?.data?.candidate_id,
            sessionId: loginDetails?.data?.session_id,
          })
        );
        // setSnackbarState({
        //     open: true,
        //     message: loginDetails?.data?.message,
        //     severity: "success",
        // });
      } else {
        setSnackbarState({
          open: true,
          message: loginDetails?.message,
          severity: 'error',
        });
      }
    }
  }, [loginDetails]);

  const handleFormEdit = (event) => {
    const { name, value } = event.target;
    setCredentials({
      ...credentials,
      [name]: value,
    });
  };

  const handleLogin = () => {
    try {
      setValidator(() => validateCredentials());
      setIsSubmited(true);
    } catch (error) {
      errorHandler(error);
    }
  };

  const validateCredentials = () => {
    let errorMessages = {};
    let emailRegex = new RegExp(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/);
    if (!credentials.email) {
      errorMessages.inputOne = 'Email is Required';
    }
    if (!credentials.password) {
      errorMessages.inputTwo = 'Password is Required';
    }
    if (!emailRegex.test(credentials.email)) {
      errorMessages.inputOne = 'Invalid Email';
    }

    return errorMessages;
  };

  const handleSnackbarClose = () => {
    setSnackbarState(() => {
      return { open: false, message: '', severity: 'info' };
    });
  };

  const loginFormProps = {
    id: 1,
    formHeading: 'Login',
    formSubHeading:
      'Login with your data that you have received on your personal email id.',
    inputOneData: {
      label: 'Email',
      type: 'email',
      name: 'email',
      value: credentials.email,
      onChange: handleFormEdit,

      // sx: {mb: 2, bgcolor: '#ffffff'}
    },
    inputTwoData: {
      label: 'Password',
      type: 'password',
      name: 'password',
      value: credentials.password,
      onChange: handleFormEdit,
    },
    checkBoxData: 'Remember Me',
    onCheckboxClick: manageRememberMe,
    checkBoxVal: rememberMeVal,
    buttonName: 'Login',
    navPath: '/profile',
    customStyle: classes.paperStyle,
  };

  return (
    <>
      {loadingAnimation ? (
        <LoadingCoffee />
      ) : (
        <Grid container>
          <Grid item sm={6} xs={12}>
            <ImageListItem>
              <img alt='Login' src={login}></img>
            </ImageListItem>
          </Grid>
          <Grid item sm={6} xs={12}>
            <CommonForm
              {...loginFormProps}
              validator={validator}
              onClick={handleLogin}
            />
          </Grid>
        </Grid>
      )}

      {/* snack bar section */}
      <GlobalSnackbar
        open={snackbarState.open}
        onClose={handleSnackbarClose}
        message={snackbarState.message}
        theme={snackbarState.severity}
      />
    </>
  );
};

export default Login;
